import type { JSX } from 'react';
import { useContent } from '@data';
import { useT } from '@/i18n';
import { SectionHeader, RevealWrapper, Tag } from '@components/ui';
import './Timeline.css';

export default function Timeline(): JSX.Element {
  const { TIMELINE } = useContent();
  const t = useT();

  return (
    <section id="parcours" className="section Timeline">
      <SectionHeader
        chip={t.sections.timeline.chip}
        chipVariant="am"
        title={t.sections.timeline.title}
        subtitle={t.sections.timeline.subtitle}
      />

      <div className="Timeline__track" role="list">
        {TIMELINE.map((item, i) => (
          <RevealWrapper key={item.id} delay={(i % 4) + 1}>
            <article
              className={`TimelineItem${item.isCurrent ? ' TimelineItem--current' : ''}${item.isEducation ? ' TimelineItem--edu' : ''}`}
              role="listitem"
              aria-labelledby={`tl-${item.id}`}
            >
              <div className="TimelineItem__marker" aria-hidden="true">
                <div className="TimelineItem__dot" />
                <div className="TimelineItem__connector" />
              </div>

              <div className="TimelineItem__body">
                <div className="TimelineItem__meta">
                  <time className="TimelineItem__date">{item.dateRange}</time>
                  {item.isCurrent && (
                    <span className="TimelineItem__badge TimelineItem__badge--now">
                      Maintenant
                    </span>
                  )}
                  {item.isEducation && (
                    <span className="TimelineItem__badge TimelineItem__badge--edu">
                      Formation
                    </span>
                  )}
                </div>

                <h3 className="TimelineItem__role" id={`tl-${item.id}`}>{item.role}</h3>
                <p className="TimelineItem__company">
                  {item.company}
                  <span className="TimelineItem__location"> · {item.location}</span>
                </p>
                <p className="TimelineItem__desc">{item.description}</p>

                {item.tags.length > 0 && (
                  <div className="TimelineItem__tags" aria-label="Compétences associées">
                    {item.tags.map(tag => (
                      <Tag key={tag}>{tag}</Tag>
                    ))}
                  </div>
                )}
              </div>
            </article>
          </RevealWrapper>
        ))}
      </div>
    </section>
  );
}
